// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles'
import ClassNames from 'classnames';
import styles from './Icon.styles';

type Props = {
  classes: any,
  className: string,
  component: any,
};

type State = {
  component: any
};

class Icon extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.state = {
      component: 'span'
    };
  }

  componentDidMount() {
    let component = this.state.component;
    if (this.props.component && this.state.component !== this.props.component) {
      component = this.props.component;
    }
    this.setState({component});
  }

  render() {
    const classes = this.props.classes;
    const parrentClasses = this.props.className;
    return (
      <this.state.component
        className={ClassNames(classes.root, `icon-${this.props.name}`, parrentClasses)}
      >
      </this.state.component>
    );
  }
}

const Component = withStyles(styles)(Icon);
export {Component as Icon};
export default Component;